module.exports = __webpack_public_path__ + "images/machine-and-deep-learning-in-python.png";